import { RelationManagerApi } from '@/features/relation-manager/api/relation-manager-api'
import Env from '@/infra/env'
import type { Observable } from 'rxjs'
import { RelationManagerStore } from '@/features/relation-manager/RelationManagerStore'
import type { FetchUserFn } from '@/features/iam'
import type RelationManager from '@/features/relation-manager/RelationManager'

export type FetchRelationManagerFn = (
  id: string,
) => Promise<RelationManager | null>

export interface RelationManagerOptions {
  token$: Observable<string>
  fetchUser: FetchUserFn
}

/**
 * Module related to managing relation managers which are assigned to a job using
 * the CSDESK api.
 */
export type RelationManagerFeature = ReturnType<typeof RelationManagerFeature>

export function RelationManagerFeature(options: RelationManagerOptions) {
  const rmApi = new RelationManagerApi({
    token$: options.token$,
    baseURL: Env.CSDESK_API,
  })

  const relationManagerStore = new RelationManagerStore(
    rmApi,
    options.fetchUser,
  )

  const fetchRelationManager: FetchRelationManagerFn = (id) =>
    relationManagerStore.fetch(id)

  return {
    fetchRelationManager,
  }
}
